/**
 * 5.1.3 금지 네트워크 설정 Store
 *
 * @since 2017-12-12
 * @author devp020
 */
export const state = () => ({
  // api url 목록
  apiUrl: {
    banNetUrl: '/api/pm/ban-net',
    ipUrl: '/ip',
    intNetUrl: '/int-net',
    appUrl: '/filter',
    serviceUrl: '/srv'
  }
})

export const mutations = {
}

export const actions = {
  // 금지 네트워크 - IP/Network 조회 (현재 설정 상태 조회)
  // - param.id : 금지 네트워크 아이디 / param.type : 유형(1: 출발지, 2: 목적지)
  async getIpNetwork ({commit, state}, param = {}) {
    try {
      const res = await this.$axios.$get(`${state.apiUrl.banNetUrl}${state.apiUrl.ipUrl}/${param.id}/${param.type}`, {loading: false})
      return res
    } catch (e) {
      return {code: 'nok', reason: e}
    }
  },
  // 금지 네트워크 - IP/Network  설정
  async addIpNetwork ({state, dispatch}, param = {}) {
    try {
      const result = await this.$axios.$post(`${state.apiUrl.banNetUrl}${state.apiUrl.ipUrl}`, param, {loading: false, successAlert: false})
      return result
    } catch (e) {
      return {code: 'nok', reason: e}
    }
  },
  // 금지 네트워크 - IP/Network 예외 설정
  async editIpNetwork ({state}, param = []) {
    try {
      const result = await this.$axios.$post(`${state.apiUrl.banNetUrl}${state.apiUrl.ipUrl}/multi`, {policy_mng_ban_net_ip_list: param}, {loading: false, successAlert: false})
      return result
    } catch (e) {
      return {code: 'nok', reason: e}
    }
  },
  // 금지네트워크 - IP/Network 삭제
  async rmIpNetwork ({state}, idList) {
    try {
      const result = await this.$axios.$put(`${state.apiUrl.banNetUrl}${state.apiUrl.ipUrl}/multi`, {policy_mng_ban_net_ip_id_list: idList}, {loading: false, successAlert: false})
      return result
    } catch (e) {
      return {code: 'nok', reason: e}
    }
  },

  // 금지 네트워크 - 내부 네트워크 조회 (현재 설정 상태 조회)
  // - param.id : 금지 네트워크 아이디 / param.type : 유형(1: 출발지, 2: 목적지)
  async getInternalNetwork ({commit, state}, param = {}) {
    try {
      const res = await this.$axios.$get(`${state.apiUrl.banNetUrl}${state.apiUrl.intNetUrl}/${param.id}/${param.type}`, {loading: false})
      return res
    } catch (e) {
      return {code: 'nok', reason: e}
    }
  },
  // 금지 네트워크 - 내부 네트워크 설정
  async addInternalNetwork ({state, dispatch}, param = {}) {
    try {
      const result = await this.$axios.$post(`${state.apiUrl.banNetUrl}${state.apiUrl.intNetUrl}`, param, {loading: false, successAlert: false})
      return result
    } catch (e) {
      return {code: 'nok', reason: e}
    }
  },
  // 금지네트워크 - 내부 네트워크 삭제
  async rmInternalNetwork ({state}, param) {
    try {
      const result = await this.$axios.$put(`${state.apiUrl.banNetUrl}${state.apiUrl.intNetUrl}`, param, {loading: false, successAlert: false})
      return result
    } catch (e) {
      return {code: 'nok', reason: e}
    }
  },

  // 금지 네트워크 - 사용자, 도메인, 애플리케이션 조회 (현재 설정 상태 조회)
  // - param.id : 금지 네트워크 아이디 / param.type : 유형(1: 출발지, 2: 목적지, 3:애플리케이션)
  async getDomainUserAppInfo ({commit, state}, param = {}) {
    try {
      const res = await this.$axios.$get(`${state.apiUrl.banNetUrl}${state.apiUrl.appUrl}/${param.id}/${param.type}`, {loading: false})
      return res
    } catch (e) {
      return {code: 'nok', reason: e}
    }
  },
  // 금지 네트워크 - 사용자, 도메인, 애플리케이션 설정
  async addDomainUserAppInfo ({state, dispatch}, param = {}) {
    try {
      const result = await this.$axios.$post(`${state.apiUrl.banNetUrl}${state.apiUrl.appUrl}`, param, {loading: false, successAlert: false})
      return result
    } catch (e) {
      return {code: 'nok', reason: e}
    }
  },
  // 금지네트워크 - 사용자, 도메인, 애플리케이션 삭제
  async rmDomainUserAppInfo ({state}, idList) {
    try {
      const result = await this.$axios.$put(`${state.apiUrl.banNetUrl}${state.apiUrl.appUrl}`, {policy_mng_ban_net_str_filter_id_list: idList}, {loading: false, successAlert: false})
      return result
    } catch (e) {
      return {code: 'nok', reason: e}
    }
  },

  // 금지 네트워크 - 서비스 조회 (현재 설정 상태 조회)
  // - id : 금지 네트워크 ID
  async getServiceInfo ({commit, state}, id = '') {
    try {
      const res = await this.$axios.$get(`${state.apiUrl.banNetUrl}${state.apiUrl.serviceUrl}/${id}`, {loading: false})
      return res
    } catch (e) {
      return {code: 'nok', reason: e}
    }
  },
  // 금지 네트워크 - 서비스 설정
  async addService ({state, dispatch}, param = {}) {
    try {
      const result = await this.$axios.$post(`${state.apiUrl.banNetUrl}${state.apiUrl.serviceUrl}`, param, {loading: false, successAlert: false})
      return result
    } catch (e) {
      return {code: 'nok', reason: e}
    }
  },
  // 금지네트워크 - 서비스 삭제
  async rmService ({state}, idList) {
    try {
      const result = await this.$axios.$put(`${state.apiUrl.banNetUrl}${state.apiUrl.serviceUrl}/multi`, {policy_mng_ban_net_srv_id_list: idList}, {loading: false, successAlert: false})
      return result
    } catch (e) {
      return {code: 'nok', reason: e}
    }
  },

  // 금지 네트워크 각 유형 설정시 호출 되는 API
  // rmInfo.id : 금지 네트워크 ID
  // rmInfo.uiType : 설정 할 타입 (1: 출발지, 2: 목적지, 3: 서비스, 4: 애플리케이션)
  // rmInfo.netType : 상세 설정 타입
  async deleteTypeNetwork ({state}, rmInfo = {}) {
    try {
      const result = await this.$axios.$delete(`${state.apiUrl.banNetUrl}/${rmInfo.id}/${rmInfo.uiType}/${rmInfo.netType}`, {successAlert: false})
      return result
    } catch (e) {
      return {code: 'nok', reason: e}
    }
  }

}
export const getters = {}
export const strict = false
